module.exports = __webpack_public_path__ + "img/jr_sapporo.f1a26cf2.jpg";